import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { FilteredFaceDetailsParams } from '../../../features/private-campaign/services/face.service';
import { TagCategory, TagWithChild, UserTagsService } from '../../../services/user/userTags.service';
import { MatInputModule } from '@angular/material/input';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { ShutterService } from '../../../features/filter/shutter/services/shutter.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertService } from '../../../services/alert/alert.service';
import { MatTooltipModule } from '@angular/material/tooltip';


/**
 * Component global de filtre des écrans
 */
@Component({
    selector: 'wncm-screen-filter',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatChipsModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        MatMenuModule,
        MatTooltipModule
    ],
    templateUrl: './wncm-screen-filter.component.html',
    styleUrl: './wncm-screen-filter.component.scss'
})
export class WncmScreenFilterComponent implements OnInit {
    //#region Variables

    @Output() public filterParamsChange = new EventEmitter<FilteredFaceDetailsParams>();


    @Input() public filterParams: FilteredFaceDetailsParams;
    /**
     * Recherch initial - utile pour affiche le 'close' dans le champ de recherche
     */
    public initSearch: string = null;
    public searchQuery: FormControl<any>;

    private readonly NB_ITEM_BY_PAGE = 20;
    /**
     * Selction des Tag avec nom, Category
     */
    selection: Map<string, TagCategory>;
    categoriesAndTag: TagCategory[];
    @ViewChildren('menuRef') menuList!: QueryList<MatMenu>;
    menuRefs = new Map<string, MatMenu>();

    @Input()
    public shutterName = 'Filtrer vos écrans';
    public menuChanged: boolean = false;

    //#endregion Variables

    // MARK: CONSTRUCTOR
    constructor(
        private readonly shutter$: ShutterService,
        private readonly alert$: AlertService
    ) {
        this.filterParams = new FilteredFaceDetailsParams();
    }

    ngOnInit(): void {
        this.searchQuery = new FormControl();
        // this.loadAllTags();
        this.initFilterParams();

    }

    ngAfterViewInit() {
        // Récupération de tous les tags dispos
        this.loadAllTags();
    }

    private loadAllTags() {
        this.shutter$.getAllTags().subscribe({
            next: (val) => {
                this.categoriesAndTag = val;

            },
            error: (err: HttpErrorResponse) => {
                console.error("WncmScreenFilterComponent - loadShutterTags() : ", err);

                this.alert$.show({
                    message: "erreur lors du chargement des tags",
                    duration: 1700
                });

            }
        });
        setTimeout(() => {
            this.menuList.forEach((menu, index) => {
                const catName = this.categoriesAndTag[index].n;
                this.menuRefs.set(catName, menu);
            });
        }, 1000);
    }

    private initFilterParams() {
        this.filterParams.page = 0;
        this.filterParams.pageSize = this.NB_ITEM_BY_PAGE;
        this.selection = UserTagsService.getTagsSelection(this.shutterName);
        this.filterParams.tags = UserTagsService.getSelectedTags(this.selection);
        this.filterParams.faceIds = UserTagsService.getSelectedTags(this.selection, 1);
    }

    onSearch() {
        this.filterParams.search = this.searchQuery.value;
        this.initSearch = this.searchQuery.value;

        //Trigger event searched
        this.filterParamsChange.emit(this.filterParams);
    }

    onFilterMenuClosed() {
        this.initFilterParams()


        //trigger event menu closed
        if (this.menuChanged) {
            this.filterParamsChange.emit(this.filterParams);
            this.menuChanged = false;
        }
    }

    getTagName(tagId: number) {
        return UserTagsService.getTagName(tagId);
    }

    getTagIcon(tagId: number) {
        return UserTagsService.getTagIcon(tagId);
    }

    removeTag(tagId: number) {
        UserTagsService.removeTagInSelection(this.shutterName, tagId);

        // remove in selection
        this.selection.forEach((tagCategory: TagCategory) => {
            let itemIndex: number = 0;
            tagCategory.t.forEach((child: TagWithChild) => {
                if (child.i === tagId) {
                    tagCategory.t.splice(itemIndex, 1);
                }
                else {
                    itemIndex++;
                }
            });
        });

        //Global Tags
        this.filterParams.tags = this.filterParams.tags.filter(
            (currentTagId) => {
                return currentTagId !== tagId;
            }
        );

        //Faces
        this.filterParams.faceIds = this.filterParams.faceIds.filter(
            (currentTagId) => {
                return currentTagId !== tagId;
            }
        );

        //trigger event tag removed
        this.filterParamsChange.emit(this.filterParams);
    }

    selectSubMenu(tag, cat) {
        if (this.selection.has(cat.n)) {
            const listTag = this.selection.get(cat.n);
            const index = listTag.t.findIndex(t => t.n === tag.n);
            if (index === -1) {
                listTag.t.push(tag)
            }
            else {
                listTag.t.splice(index, 1);
                if (listTag.t.length === 0)
                    this.selection.delete(cat.n);
            }
        }
        else {
            this.selection.set(cat.n, { i: tag.i, c: null, n: tag.n, t: [tag] });
        }
        UserTagsService.setTagsSelection(this.shutterName, this.selection);
        this.menuChanged = true;
        this.initFilterParams();
    }
}
